import { render } from "./QuienesSomos.vue?vue&type=template&id=00720f84&scoped=true"
import script from "./QuienesSomos.vue?vue&type=script&lang=js"
export * from "./QuienesSomos.vue?vue&type=script&lang=js"

import "./QuienesSomos.vue?vue&type=style&index=0&id=00720f84&lang=scss&scoped=true"

import exportComponent from "/var/www/clients/client1/web6/web/cartamovil-vue/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-00720f84"]])

export default __exports__